/* =============================================================================
 * Arranque do modo offline.
 *
 * Este arquivo existe para quebrar um ciclo: os pacotes importam o
 * ServicoAplicacao (e' de la' que sai o download), e o ServicoAplicacao importa o
 * NUCLEO (offline.js) para saber se responde local. Se o nucleo importasse os
 * pacotes, o ciclo se fecharia - entao quem os conhece e' este modulo, que
 * ninguem de dentro importa de volta.
 *
 * E' CHAMADO CEDO E E' BLOQUEANTE (app/main.js). O espelho de pacotes em memoria
 * precisa estar carregado antes da PRIMEIRA chamada de servico: se o boot
 * perguntasse "tenho o shell guardado?" antes do indice chegar, a resposta seria
 * "nao" e o app abriria vazio - com o conteudo baixado ali, intacto, na base.
 * ========================================================================== */

import { iniciarConexao, podeUsarOffline } from './conexao.js';
import { recarregarIndice } from './offline.js';
import { solicitarPersistencia } from './armazenamento.js';
import { registrarPacoteNavegacao } from './pacote-navegacao.js';
import { registrarPacoteCompeticao } from './pacote-competicao.js';

let iniciado = false;

export async function iniciarOffline() {
    if (iniciado) return;
    iniciado = true;

    try {
        iniciarConexao();
        registrarPacoteNavegacao();
        registrarPacoteCompeticao();

        //Sem o recurso ligado nao ha' indice para carregar - e nem se pede
        //persistencia de dados que nao existem.
        if (!podeUsarOffline()) return;

        solicitarPersistencia();
        await recarregarIndice();
    } catch (e) {
        //O modo offline nunca pode impedir o app de subir.
        console.warn('[offline] não foi possível iniciar', e);
    }
}
